import React from 'react';
import '../SharedControlPanel.scss';
import './AggregatorPanel.scss';
import ProcessingDelayInput from '../../../../InputComponents/ProcessingDelayInput/ProcessingDelayInput';
import ProcessingTimeoutInput from '../../../../InputComponents/ProcessingTimeoutInput/ProcessingTimeoutInput';
import BufferDelayInput from '../../../../InputComponents/BufferDelayInput/BufferDelayInput';
import CharsPerLineInput from '../../../../InputComponents/CharsPerLineInput/CharsPerLineInput';
import WordsPerMinuteInput from '../../../../InputComponents/WordsPerMinuteInput/WordsPerMinuteInput';
import MinDisplayTimeInput from '../../../../InputComponents/MinDisplayTimeInput/MinDisplayTimeInput';
import MaxCommandsInput from '../../../../InputComponents/MaxCommandsInput/MaxCommandsInput';
import useProject from '../../../../../hooks/useProject';
import { CaptionModeEnum } from '../../../../../types/enums/CaptionModeEnum';
import { AggregatorOutputModeEnum } from '../../../../../types/enums/AggregatorOutputModeEnum';

const AggregatorPanel = () => {
  const { project } = useProject();

  return (
    <div className="aggregator-panel">
      <div className="aggregator-panel-section level">
        <div className="aggregator-panel-section-content">
          <div className="aggregator-panel-section-content-value">
            <div className="aggregator-panel-column">
              <BufferDelayInput />
            </div>

            {project?.encoder?.aggregatorOutputMode === AggregatorOutputModeEnum.Popon &&
              project?.createdByUser?.isAdmin === true &&  (              
              <>
                <div className="aggregator-panel-column">
                  <CharsPerLineInput />
                </div>
              </>
            )}

            {/* <div className="aggregator-panel-column">
              <LineCountInput />
            </div> */}

            <div className="aggregator-panel-column">
              <ProcessingDelayInput />
            </div>

            {project?.encoder?.aggregatorOutputMode === AggregatorOutputModeEnum.Popon && (
              <>
                <div className="aggregator-panel-column">
                  <WordsPerMinuteInput />
                </div>
                
                <div className="aggregator-panel-column">
                  <MinDisplayTimeInput />
                </div>

                <div className="aggregator-panel-column">
                  <ProcessingTimeoutInput />
                </div>
              </>
            )}

            {project?.encoder?.captionMode === CaptionModeEnum.Closed &&
            project?.createdByUser?.isAdmin === true &&  (
              <>
                <div className="aggregator-panel-column">
                  <MaxCommandsInput />
                </div>
              </>
            )}            
          </div>
        </div>
      </div>      
    </div>
  );
};

export default React.memo(AggregatorPanel);
